import { useCallback, useContext, useMemo } from "react";
import { useCookies } from "react-cookie";

import { AuthContext } from "../context/AuthProvider";

const KEY = "RESTORE";
const TEN_MINUTES = 60 * 10;
const COOKIE_OPTIONS = {
  path: "/",
  maxAge: TEN_MINUTES,
};

export const useRestoreUrl = () => {
  const [cookies, setCookie, removeCookie] = useCookies([KEY]);

  const store = useCallback(
    (location: { pathname: string; search: string }) => {
      const val = btoa(
        JSON.stringify({
          pathname: location.pathname,
          search: new URLSearchParams(location.search).toString(),
        }),
      );

      setCookie(KEY, val, COOKIE_OPTIONS);
    },
    [location, setCookie],
  );

  const clear = useCallback(() => {
    removeCookie(KEY, COOKIE_OPTIONS);
  }, [removeCookie]);

  const url = useMemo(() => {
    if (!cookies[KEY]) return undefined;

    try {
      const v = cookies[KEY];
      if (!v) return null;

      const { pathname, search } = JSON.parse(atob(cookies[KEY]));

      if (pathname) {
        const url = new URL(pathname, window.location.origin);
        const urlSearch = new URLSearchParams(search);
        return [url.pathname, urlSearch.toString()].filter(Boolean).join("?");
      }
    } catch (e) {
      console.error("Failed to parse restore url", e);
    }
  }, [cookies]);

  return {
    url,
    store,
    clear,
  };
};

export const useAuth = () => {
  return useContext(AuthContext);
};
